<div class="flex min-h-[calc(100vh-48px)] flex-col gap-5 bg-light-color px-6 py-6 font-base text-dark-color">
  <header class="flex flex-col gap-4 rounded-2xl bg-gradient-to-r from-[var(--primary-color)] via-[var(--primary-color-hover)] to-[var(--second-color)] px-6 py-6 text-light-color shadow-[0_14px_40px_var(--box-shadow-color)] md:flex-row md:items-start md:justify-between md:gap-6">
    <div class="flex flex-col gap-2">
      <p class="text-xs uppercase tracking-[0.12em] text-light-color/80">Nutrições</p>
      <h1 class="text-2xl font-semibold leading-tight">Gerencie suas nutrições</h1>
      <p class="max-w-3xl text-sm text-light-color/90">
        Cadastre novos fluxos, importe números via CSV e acompanhe as mensagens configuradas.
      </p>
    </div>
    <div class="grid grid-cols-2 gap-3 text-sm md:grid-cols-2">
      <div class="rounded-xl bg-white/10 px-4 py-3 shadow">
        <p class="m-0 text-xs uppercase tracking-[0.12em] text-light-color/80">Nutrições liberadas</p>
        <strong class="text-lg">{{ nutricoesLiberadas }}</strong>
      </div>
      <div class="rounded-xl bg-white/10 px-4 py-3 shadow">
        <p class="m-0 text-xs uppercase tracking-[0.12em] text-light-color/80">Nutrições cadastradas</p>
        <strong class="text-lg">{{ nutricoesCadastradas }}</strong>
      </div>
    </div>
  </header>

  <section class="flex flex-col gap-4 rounded-xl border border-border-color bg-white px-5 py-5 shadow-[0_12px_36px_var(--box-shadow-color)]">
    <div class="flex flex-col gap-3 md:flex-row md:items-center md:justify-between">
      <div class="flex items-center gap-2 text-sm text-dark-color">
        <mat-icon>auto_graph</mat-icon>
        <span>Controle de nutrições e entradas de números.</span>
      </div>
      <div class="flex flex-wrap gap-2">
        <button
          type="button"
          (click)="openModalImportFile()"
          class="inline-flex items-center gap-2 rounded-base border border-border-color bg-white px-4 py-2 text-sm font-semibold text-dark-color shadow-sm transition hover:border-primary-color">
          <mat-icon>upload_file</mat-icon>
          Importar CSV
        </button>
        <button
          type="button"
          (click)="openModalCreateNutricao()"
          class="inline-flex items-center gap-2 rounded-base bg-primary-color px-4 py-2 text-sm font-semibold text-white shadow-md transition hover:bg-primary-hover">
          <mat-icon>add</mat-icon>
          Criar Nutrição
        </button>
      </div>
    </div>

    <div class="grid grid-cols-1 gap-4 lg:grid-cols-2">
      <div class="rounded-xl border border-border-color bg-white p-4 shadow">
        <h3 class="text-base font-semibold text-dark-color">Inserção manual</h3>
        <p class="text-sm text-dark-color/70">Adicione um número em uma nutrição e canal específicos.</p>
        <form class="mt-3 space-y-3" [formGroup]="formInsercaoManual" (ngSubmit)="onSubmit()">
          <label class="block text-sm text-dark-color">
            Número
            <input
              type="text"
              placeholder="(38) 99999-9999"
              maxlength="15"
              formControlName="numero"
              (keyup)="formatNumber()"
              class="mt-1 w-full rounded-base border border-border-color px-3 py-2 text-sm outline-none focus:border-primary-color" />
          </label>
          <p
            *ngIf="
              formInsercaoManual.get('numero')?.errors?.['required'] && formInsercaoManual.get('numero')?.touched
            "
            class="text-xs font-medium text-red-600">
            Campo obrigatório
          </p>
          <p
            *ngIf="
              formInsercaoManual.get('numero')?.errors?.['pattern'] && formInsercaoManual.get('numero')?.touched
            "
            class="text-xs font-medium text-red-600">
            Formato inválido. Use (XX) XXXXX-XXXX.
          </p>

          <label class="block text-sm text-dark-color">
            Nutrição
            <select
              formControlName="idnutricao"
              class="mt-1 w-full rounded-base border border-border-color px-3 py-2 text-sm outline-none focus:border-primary-color">
              <option value="" disabled selected>Selecione uma Nutrição</option>
              <option *ngFor="let nutricao of listNutricoes; trackBy: trackByIdNutricoes" [value]="nutricao.idnutricao">
                {{ nutricao.nome }}
              </option>
            </select>
          </label>
          <p *ngIf="formInsercaoManual.get('idnutricao')?.errors?.['required'] && formInsercaoManual.get('idnutricao')?.touched" class="text-xs font-medium text-red-600">
            Selecione uma nutrição.
          </p>

          <label class="block text-sm text-dark-color">
            Canal
            <select
              formControlName="idcanal"
              class="mt-1 w-full rounded-base border border-border-color px-3 py-2 text-sm outline-none focus:border-primary-color">
              <option value="" disabled selected>Selecione um Canal</option>
              <option *ngFor="let canal of listCanais; trackBy: trackByIdCanais" [value]="canal.idcanal">
                {{ canal.nomefila }}
              </option>
            </select>
          </label>
          <p *ngIf="formInsercaoManual.get('idcanal')?.errors?.['required'] && formInsercaoManual.get('idcanal')?.touched" class="text-xs font-medium text-red-600">
            Selecione um canal.
          </p>

          <button
            class="mt-2 inline-flex w-full items-center justify-center gap-2 rounded-base bg-primary-color px-4 py-2 text-sm font-semibold text-white shadow transition hover:bg-primary-hover disabled:cursor-not-allowed disabled:opacity-60"
            [disabled]="formInsercaoManual.invalid">
            Salvar
          </button>
        </form>
      </div>

      <div class="rounded-xl border border-border-color bg-white shadow">
        <div class="border-b border-border-color px-4 py-3 flex items-center justify-between">
          <h3 class="text-base font-semibold text-dark-color m-0">Nutrições</h3>
          <span class="text-sm text-dark-color/70">Total: {{ listNutricoes.length || 0 }}</span>
        </div>
        <div class="overflow-x-auto">
          <table class="min-w-full divide-y divide-border-color text-sm">
            <thead class="bg-light-color/60">
              <tr>
                <th class="px-4 py-3 text-left font-semibold text-dark-color">Código</th>
                <th class="px-4 py-3 text-left font-semibold text-dark-color">Nome</th>
                <th class="px-4 py-3 text-right font-semibold text-dark-color">Opções</th>
              </tr>
            </thead>
            <tbody class="divide-y divide-border-color">
              <tr
                *ngFor="let nutricao of listNutricoes; let i = index; trackBy: trackByIdNutricoes"
                class="hover:bg-light-color/60 transition">
                <td class="px-4 py-3">
                  <button
                    type="button"
                    class="max-w-[260px] truncate rounded-lg bg-light-color px-2 py-1 text-left text-xs font-mono text-dark-color hover:bg-border-color/40"
                    title="Copiar código"
                    (click)="copyCodeNutricao(nutricao.uuid)">
                    {{ nutricao.uuid }}
                  </button>
                </td>
                <td class="px-4 py-3 text-dark-color">{{ nutricao.nome }}</td>
                <td class="px-4 py-3">
                  <div class="flex justify-end gap-2">
                    <button
                      class="flex h-9 w-9 items-center justify-center rounded-lg border border-border-color bg-white text-dark-color transition hover:border-primary-color hover:text-primary-color"
                      title="Rastrear números"
                      type="button"
                      (click)="openModalVisualizarNumerosNutricao(nutricao.idnutricao)">
                      <mat-icon>search</mat-icon>
                    </button>
                    <button
                      class="flex h-9 w-9 items-center justify-center rounded-lg border border-border-color bg-white text-dark-color transition hover:border-primary-color hover:text-primary-color"
                      title="Visualizar mensagens"
                      type="button"
                      (click)="openModalVisualizationMessagesOnNutrition(nutricao.idnutricao)">
                      <mat-icon>visibility</mat-icon>
                    </button>
                    <button
                      class="flex h-9 w-9 items-center justify-center rounded-lg border border-border-color bg-white text-dark-color transition hover:border-primary-color hover:text-primary-color"
                      title="Configurar mensagens"
                      type="button"
                      (click)="openModalCadastrarMensagemNutricao(nutricao.idnutricao)">
                      <mat-icon>edit</mat-icon>
                    </button>
                    <button
                      class="flex h-9 w-9 items-center justify-center rounded-lg border border-border-color bg-white text-red-600 transition hover:border-primary-hover hover:text-primary-hover"
                      title="Deletar"
                      type="button"
                      (click)="openModalDeleteNutricao(i)">
                      <mat-icon>delete</mat-icon>
                    </button>
                  </div>
                </td>
              </tr>
              <tr *ngIf="!listNutricoes.length">
                <td colspan="3" class="px-4 py-6 text-center text-dark-color/70">
                  Nenhuma nutrição cadastrada.
                </td>
              </tr>
            </tbody>
          </table>
        </div>
      </div>
    </div>
  </section>
</div>

<!-- MODAL: Importar CSV -->
<ng-container *ngIf="modalImportFile">
  <div class="fixed inset-0 z-50 grid place-items-center p-4">
    <div class="fixed inset-0 bg-black/50 backdrop-blur-sm" (click)="closeModalImportFile()"></div>
    <div role="dialog" aria-modal="true" class="relative w-full max-w-xl rounded-2xl border border-border-color bg-white p-5 shadow-xl">
      <div class="flex items-center justify-between border-b border-border-color pb-3">
        <h3 class="text-base font-semibold text-dark-color">Importar via CSV</h3>
        <button class="flex h-9 w-9 items-center justify-center rounded-lg border border-border-color bg-white text-dark-color transition hover:border-primary-color" (click)="closeModalImportFile()">
          <mat-icon>close</mat-icon>
        </button>
      </div>

      <form class="mt-4 space-y-4 w-full" [formGroup]="formCsv">
        <p class="text-xs text-dark-color/70">OBS: Os números devem estar na coluna A do arquivo.</p>
        <div class="relative flex flex-col items-center justify-center rounded-2xl border-2 border-dashed border-border-color px-4 py-8 text-center hover:border-primary-color">
          <mat-icon class="mb-2">upload_file</mat-icon>
          <p class="text-sm text-dark-color">Upload do arquivo CSV</p>
          <input
            type="file"
            accept=".csv"
            (change)="onFileChange($event)"
            [style.pointer-events]="fileName != '' ? 'none' : 'auto'"
            class="absolute inset-0 h-full w-full cursor-pointer opacity-0" />
          <div *ngIf="fileName" class="mt-3 flex w-full items-center justify-between rounded-xl bg-light-color px-3 py-2 text-sm text-dark-color">
            <span class="truncate">{{ fileName }}</span>
            <button type="button" (click)="deleteFileSelect()" class="flex h-8 w-8 items-center justify-center rounded-lg border border-border-color bg-white text-red-600 transition hover:border-primary-color">
              <mat-icon>delete</mat-icon>
            </button>
          </div>
        </div>

        <div class="grid grid-cols-1 sm:grid-cols-2 gap-3 w-full">
          <label class="block w-full text-sm text-dark-color">
            Nutrição
            <select
              formControlName="idnutricao"
              class="mt-1 block w-full rounded-base border border-border-color px-3 py-2 text-sm outline-none focus:border-primary-color">
              <option disabled selected>Selecione uma Nutrição</option>
              <option *ngFor="let nutricao of listNutricoes; trackBy: trackByIdNutricoes" [value]="nutricao.idnutricao">
                {{ nutricao.nome }}
              </option>
            </select>
          </label>

          <label class="block w-full text-sm text-dark-color">
            Canal
            <select
              formControlName="idcanal"
              class="mt-1 block w-full rounded-base border border-border-color px-3 py-2 text-sm outline-none focus:border-primary-color">
              <option disabled selected>Selecione um Canal</option>
              <option *ngFor="let canal of listCanais; trackBy: trackByIdCanais" [value]="canal.idcanal">
                {{ canal.nomefila }}
              </option>
            </select>
          </label>
        </div>

        <div class="flex justify-end gap-2 pt-2 w-full">
          <button type="button" class="rounded-base border border-border-color bg-dark-color px-4 py-2 text-sm text-white transition hover:border-primary-color" (click)="closeModalImportFile()">
            Cancelar
          </button>
          <button type="button" class="rounded-base bg-primary-color px-4 py-2 text-sm font-semibold text-white transition hover:bg-primary-hover" (click)="onSubmitCsv()">
            Salvar
          </button>
        </div>
      </form>
    </div>
  </div>
</ng-container>

<!-- MODAL: Criar Nutrição -->
<ng-container *ngIf="modalCreateNutricao">
  <div class="fixed inset-0 z-50 grid place-items-center p-4">
    <div class="fixed inset-0 bg-black/50 backdrop-blur-sm" (click)="closeModalCreateNutricao()"></div>
    <div role="dialog" aria-modal="true" class="relative w-full max-w-md rounded-2xl border border-border-color bg-white p-5 shadow-xl">
      <div class="mb-3 flex items-center justify-between">
        <h3 class="text-base font-semibold text-dark-color">Cadastrar Nutrição</h3>
        <button class="flex h-9 w-9 items-center justify-center rounded-lg border border-border-color bg-white text-dark-color transition hover:border-primary-color" (click)="closeModalCreateNutricao()">
          <mat-icon>close</mat-icon>
        </button>
      </div>

      <form class="space-y-3 w-full" [formGroup]="formCreateNutricao" (ngSubmit)="onSubmitCreateNutricao()">
        <label class="block w-full text-sm text-dark-color">
          Nome da Nutrição
          <input
            type="text"
            placeholder="Insira o nome da Nutrição"
            formControlName="nome"
            class="mt-1 block w-full rounded-base border border-border-color px-3 py-2 text-sm outline-none focus:border-primary-color" />
        </label>

        <div class="flex justify-end gap-2 pt-2 w-full">
          <button type="button" class="rounded-base border border-border-color bg-dark-color px-4 py-2 text-sm text-white transition hover:border-primary-color" (click)="closeModalCreateNutricao()">
            Cancelar
          </button>
          <button type="submit" class="rounded-base bg-primary-color px-4 py-2 text-sm font-semibold text-white transition hover:bg-primary-hover disabled:opacity-60 disabled:cursor-not-allowed">
            Cadastrar
          </button>
        </div>
      </form>
    </div>
  </div>
</ng-container>

<!-- MODAL: Deletar Nutrição -->
<ng-container *ngIf="modalDeleteNutricao">
  <div class="fixed inset-0 z-50 grid place-items-center p-4">
    <div class="fixed inset-0 bg-black/60 backdrop-blur-sm" (click)="closeModalDeleteNutricao()"></div>
    <div role="dialog" aria-modal="true" class="relative w-full max-w-md rounded-2xl border border-border-color bg-white p-6 shadow-xl">
      <div class="flex items-center justify-between">
        <h3 class="text-base font-semibold text-dark-color">Confirmar exclusão</h3>
        <button class="flex h-9 w-9 items-center justify-center rounded-lg border border-border-color bg-white text-dark-color transition hover:border-primary-color" (click)="closeModalDeleteNutricao()">
          <mat-icon>close</mat-icon>
        </button>
      </div>
      <p class="mt-3 text-sm text-dark-color/80">Deseja realmente deletar este item?</p>
      <div class="mt-5 flex items-center justify-end gap-3">
        <button type="button" class="rounded-base border border-border-color bg-dark-color px-4 py-2 text-sm text-white transition hover:border-primary-color" (click)="closeModalDeleteNutricao()">
          Cancelar
        </button>
        <button type="button" class="rounded-base bg-primary-color px-4 py-2 text-sm font-semibold text-white transition hover:bg-primary-hover" (click)="deleteNutricao()">
          Confirmar
        </button>
      </div>
    </div>
  </div>
</ng-container>

<!-- MODAL: Cadastrar Mensagem -->
<ng-container *ngIf="modalCadastrarMensagemNutricao">
  <div class="fixed inset-0 z-50 grid place-items-center p-4">
    <div class="fixed inset-0 bg-black/50 backdrop-blur-sm" (click)="closeModalCadastrarMensagemNutricao()"></div>
    <div role="dialog" aria-modal="true" class="relative w-full max-w-xl rounded-2xl border border-border-color bg-white p-5 shadow-xl">
      <div class="mb-3 flex items-center justify-between">
        <h3 class="text-base font-semibold text-dark-color">Cadastrar Mensagem</h3>
        <button class="flex h-9 w-9 items-center justify-center rounded-lg border border-border-color bg-white text-dark-color transition hover:border-primary-color" (click)="closeModalCadastrarMensagemNutricao()">
          <mat-icon>close</mat-icon>
        </button>
      </div>

      <form [formGroup]="formCadastrarMensagemNutricao" class="space-y-3">
        <label class="block text-sm text-dark-color">
          Mensagem
          <textarea
            placeholder="Digite sua mensagem"
            formControlName="message"
            rows="4"
            class="mt-1 w-full resize-y rounded-base border border-border-color px-3 py-2 text-sm outline-none focus:border-primary-color"></textarea>
        </label>

        <div class="grid grid-cols-1 sm:grid-cols-3 gap-3">
          <label class="block text-sm text-dark-color sm:col-span-2">
            Unidade de tempo
            <select
              formControlName="unidademedida"
              class="mt-1 w-full rounded-base border border-border-color px-3 py-2 text-sm outline-none focus:border-primary-color">
              <option *ngFor="let unidade of unidadeMedidas" [value]="unidade.valor" selected>{{ unidade.nome }}</option>
            </select>
          </label>

          <label class="block text-sm text-dark-color">
            Quantidade
            <input
              type="number"
              min="1"
              placeholder="Ex.: 3"
              formControlName="time"
              class="mt-1 w-full rounded-base border border-border-color px-3 py-2 text-sm outline-none focus:border-primary-color" />
          </label>
        </div>

        <div class="flex items-center justify-end gap-3 pt-2">
          <button type="button"
            (click)="onSubmitCadastrarMensagemNutricao()"
            class="rounded-base bg-primary-color px-4 py-2 text-sm font-semibold text-white shadow transition hover:bg-primary-hover">
            Salvar
          </button>
          <button type="button"
            (click)="closeModalCadastrarMensagemNutricao()"
            class="rounded-base border border-border-color bg-white px-4 py-2 text-sm font-medium text-dark-color transition hover:border-primary-color">
            Fechar
          </button>
        </div>
      </form>
    </div>
  </div>
</ng-container>

<!-- MODAL: Visualizar Mensagens -->
<ng-container *ngIf="modalVisualizarMensagemNutricao">
  <div class="fixed inset-0 z-50 grid place-items-center p-4">
    <div class="fixed inset-0 bg-black/50 backdrop-blur-sm" (click)="closeModalVisualizationMessagesOnNutrition()"></div>
    <div role="dialog" aria-modal="true" class="relative w-full max-w-4xl rounded-2xl border border-border-color bg-white shadow-xl">
      <div class="flex items-center justify-between border-b border-border-color px-5 py-4">
        <h3 class="text-base font-semibold text-dark-color">Mensagens da Nutrição</h3>
        <button class="flex h-9 w-9 items-center justify-center rounded-lg border border-border-color bg-white text-dark-color transition hover:border-primary-color" (click)="closeModalVisualizationMessagesOnNutrition()">
          <mat-icon>close</mat-icon>
        </button>
      </div>

      <div class="px-5 py-4">
        <div class="overflow-x-auto rounded-xl border border-border-color">
          <table class="min-w-full divide-y divide-border-color text-sm">
            <thead class="bg-light-color/60 text-left font-semibold text-dark-color">
              <tr>
                <th class="px-4 py-3">Mensagem</th>
                <th class="px-4 py-3">Tempo após entrada</th>
                <th class="px-4 py-3 text-right">Opções</th>
              </tr>
            </thead>
            <tbody class="divide-y divide-border-color">
              <tr *ngFor="let message of listMessagesRegisteredInNutrition; trackBy: trackByIdMessages; let i = index" class="hover:bg-light-color/60 transition">
                <td class="px-4 py-3 text-dark-color">{{ message.message }}</td>
                <td class="px-4 py-3 text-dark-color">
                  {{ message.time }} {{ message.unidademedida }}
                </td>
                <td class="px-4 py-3 text-right">
                  <button class="flex h-9 w-9 items-center justify-center rounded-lg border border-border-color bg-white text-red-600 transition hover:border-primary-hover hover:text-primary-hover"
                          (click)="deleteMessageInNutrition(i)">
                    <mat-icon>delete</mat-icon>
                  </button>
                </td>
              </tr>

              <tr *ngIf="!listMessagesRegisteredInNutrition?.length">
                <td colspan="3" class="px-4 py-6 text-center text-dark-color/70">
                  Nenhuma mensagem cadastrada.
                </td>
              </tr>
            </tbody>
          </table>
        </div>
      </div>
    </div>
  </div>
</ng-container>

<!-- MODAL: Visualizar Números -->
<ng-container *ngIf="modalVisualizarNumerosNutricao">
  <div class="fixed inset-0 z-50 grid place-items-center p-4">
    <div class="fixed inset-0 bg-black/50 backdrop-blur-sm" (click)="closeModalVisualizarNumerosNutricao()"></div>
    <div role="dialog" aria-modal="true" class="relative w-full max-w-lg rounded-2xl border border-border-color bg-white shadow-xl">
      <div class="flex items-center justify-between border-b border-border-color px-5 py-4">
        <h3 class="text-base font-semibold text-dark-color">Números desta Nutrição</h3>
        <button class="flex h-9 w-9 items-center justify-center rounded-lg border border-border-color bg-white text-dark-color transition hover:border-primary-color" (click)="closeModalVisualizarNumerosNutricao()">
          <mat-icon>close</mat-icon>
        </button>
      </div>

      <div class="px-5 py-4">
        <div class="overflow-x-auto rounded-xl border border-border-color">
          <table class="min-w-full divide-y divide-border-color text-sm">
            <thead class="bg-light-color/60 text-left font-semibold text-dark-color">
              <tr>
                <th class="px-4 py-3">Número</th>
                <th class="px-4 py-3 text-right">Opções</th>
              </tr>
            </thead>
            <tbody class="divide-y divide-border-color">
              <tr *ngFor="let number of listNumbersInNutrition; trackBy: trackByIndexNumbers; let i = index" class="hover:bg-light-color/60 transition">
                <td class="px-4 py-3 text-dark-color">{{ number.numero }}</td>
                <td class="px-4 py-3 text-right">
                  <button class="flex h-9 w-9 items-center justify-center rounded-lg border border-border-color bg-white text-red-600 transition hover:border-primary-hover hover:text-primary-hover"
                          (click)="deleteNumberInNutrition(i)">
                    <mat-icon>delete</mat-icon>
                  </button>
                </td>
              </tr>

              <tr *ngIf="!listNumbersInNutrition?.length">
                <td colspan="2" class="px-4 py-6 text-center text-dark-color/70">
                  Nenhum número encontrado.
                </td>
              </tr>
            </tbody>
          </table>
        </div>
      </div>
    </div>
  </div>
</ng-container>

<app-alert></app-alert>
<app-loading-modal></app-loading-modal>
